export type ElementAttrs = Record<string, string | number | boolean | null | undefined>;

export function clearChildren(node: Element | DocumentFragment): void {
  node.replaceChildren();
}

export function appendTextNode(parent: Node, text: string): Text {
  const node = document.createTextNode(text);
  parent.appendChild(node);
  return node;
}

export function createElement<K extends keyof HTMLElementTagNameMap>(
  tagName: K,
  options?: {
    className?: string;
    text?: string;
    attrs?: ElementAttrs;
  },
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tagName);
  if (options?.className) {
    node.className = options.className;
  }
  if (typeof options?.text === "string") {
    node.textContent = options.text;
  }
  if (options?.attrs) {
    setAttributes(node, options.attrs);
  }
  return node;
}

export function setAttributes(node: HTMLElement, attrs: ElementAttrs): void {
  Object.entries(attrs).forEach(([key, value]) => {
    if (value === null || value === undefined || value === false) {
      return;
    }
    if (value === true) {
      node.setAttribute(key, "");
      return;
    }
    node.setAttribute(key, String(value));
  });
}
